import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

import crudsService from "services/cruds-service";
import { useParams } from "react-router-dom";
import i18n from "i18n";
import prepareNewArr from "helper/prepareNewArr";
import deepDiff from "helper/deep-diff";
import LangForm from "./langForm";
import MainInfo from "./MainInfo";
import getEmptyFields from "helper/getEmptyFields";
import { useLocation } from "react-router-dom";
import MDAlert from "components/MDAlert";

function AddFaq() {
  const { t } = i18n;
  const baseUrl = process.env.REACT_APP_API_URL;
  let { pathname } = useLocation();
  const { id } = useParams();
  let route = id
    ? pathname.split("/")[pathname.split("/").length - 2]
    : pathname.split("/")[pathname.split("/").length - 1];
  console.log(id, route);

  const [project, setProject] = useState({
    id: null,
    status: "draft",
    sequence: 0,
    translations: {},
  });
  const [info, setInfo] = useState({
    id: null,
    status: "draft",
    sequence: 0,
    translations: {},
  });
  const [linfo, setLInfo] = useState({
    translations: {},
  });

  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const errorChk = {
    status: "draft",
    sequence: 0,
    translations: { name: "" },
  };

  const getProjects = async () => {
    const response = await crudsService.getAllData(
      `items/${route}/${id}?fields=*,translations.*,translations.languages_code.name,translations.languages_code.code`
    );

    setProject((prevProject) => ({
      ...prevProject,
      translations: response.data.translations.reduce((acc, translation) => {
        acc[translation.languages_code.code] = { ...translation };
        return acc;
      }, {}),
      name: response.data.translations[0]?.name,
      id: response.data.id,
      // sequence: response.data.sequence,
      // status: response.data.status,
    }));
  };

  //if id change (when click edit from projects page) get the project data
  useEffect(() => {
    if (!id) return;
    getProjects();
  }, [id]);

  // useEffect(() => {
  //   if (!project) return;

  //   setInfo({
  //     sequence: project?.sequence,
  //     status: project?.status,
  //   });
  // }, [project]);

  const changeHandler = (e, lang) => {
    if (lang) {
      setLInfo({
        translations: {
          ...linfo.translations,
          [lang]: {
            ...linfo.translations[lang],
            [e.target.name]: e.target.value,
            languages_code: lang,
          },
        },
      });
    } else {
      // setInfo({
      //   ...info,
      //   [e.target.name]: e.target.value,
      // });
    }
  };

  // const autoSwitchChangeHandler = (name, v) => {
  //   setInfo({
  //     ...info,
  //     [name]: v,
  //   });
  // };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      // const { status, ...other } = info;
      const { translations, ...other } = errorChk;

      let obj = {
        // ...getEmptyFields(info, "", other),
        ...getEmptyFields(linfo.translations["ar-SA"], "ar-SA", translations),
        ...getEmptyFields(
          linfo.translations["en-US"] || { name: "" },
          "en-US",
          translations
        ),
        ...getEmptyFields(
          linfo.translations["tr-TR"] || { name: "" },
          "tr-TR",
          translations
        ),
      };
      // Object.assign(obj, getEmptyFields(linfo.translations["ar-SA"], "ar-SA"));
      // Object.assign(
      //   obj,
      //   getEmptyFields(
      //     linfo.translations["en-US"] || { title: "", summary: "" },
      //     "en-US"
      //   )
      // );
      // Object.assign(
      //   obj,
      //   getEmptyFields(
      //     linfo.translations["tr-TR"] || { title: "", summary: "" },
      //     "tr-TR"
      //   )
      // );
      const hasErrors = Object.values(obj).some((v) => v === true);

      if (hasErrors) {
        setErrors(obj);
        return; // stop
      }

      const trns = Object.values(linfo.translations);

      if (id) {
        await crudsService.updateItem(`items/${route}/${id}`, {
          // sequence: info?.sequence,
          // status: info?.status,
          translations: trns,
        });
      } else {
        await crudsService.createItem(`items/${route}`, {
          // sequence: info?.sequence,
          // status: info?.status,
          translations: trns,
        });
      }
      setNotification({
        value: true,
        color: "success",
        text: "تم الحفظ بنجاح",
      });
    } catch (err) {
      console.error(err);
      setNotification({
        value: true,
        color: "error",
        text: "حدث خطأ ما، الرجاء المحاولة مرة أخرى",
      });
    }
  };

  return (
    <DashboardLayout>
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium" color="info">
                {project?.name || t(route)}
              </MDTypography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={submitHandler}
                >
                  {t("save")}
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        {notification.value === true && (
          <MDAlert color={notification.color} mt="20px">
            <MDTypography variant="body2" color="white">
              {notification.text}
            </MDTypography>
          </MDAlert>
        )}
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={8}>
            {/* <Grid item xs={12} lg={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <MainInfo
                  changeHandler={changeHandler}
                  autoSwitchChangeHandler={autoSwitchChangeHandler}
                  setInfo={setInfo}
                  info={info}
                  setErrors={setErrors}
                  errors={errors}
                  notification={notification}
                  setNotification={setNotification}
                />
              </Grid>
            </Grid>
          </Grid> */}
            <Grid item xs={12} lg={12}>
              <LangForm
                project={project}
                changeHandler={changeHandler}
                setInfo={setLInfo}
                info={linfo}
                notification={notification}
                setNotification={setNotification}
                errors={errors}
                setErrors={setErrors}
              />
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddFaq;
